import PropTypes from 'prop-types';
import React from 'react';
import _Empty from 'lodash/isEmpty';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import _debounce from 'lodash/debounce';
import './main.less';

import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';
import Input from '../../../shared/form-elements/input';
import Calendar from '../../../shared/calendar/main';

const Form = props => {
	const submit = data => props.increaseApproveFormSubmit(data);
	const fetchOffersApproveData = props.fetchOffersApproveData;
	const { target_approve, offers, countries } = props.increaseApproveFormData;

	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			{
				!!props.dailyApprovesList &&
				!!props.dailyApprovesList.length &&
				<div className="daily-approve-alert">
					<p>Attention! Affiliate has daily approve settings!</p>
					{props.dailyApprovesList.slice(0, 3).map((item, i) => <p key={i}>{item.country} {item.offer}</p>)}
					{ props.dailyApprovesList.length > 3 && <p>...</p> }
				</div>
			}

			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className="ui-control-bar__item-position">
					<Calendar
						{...props.affiliateApproveIncreaseCalendar}
						onInit={props.affiliateApproveIncreaseCalendarInit}
						onToggle={props.affiliateApproveIncreaseCalendarToggle}
						onChange={data => {
							props.affiliateApproveIncreaseCalendarChange(data);
							setTimeout(fetchOffersApproveData, 1500);
						}}
						onApply={props.affiliateApproveIncreaseCalendarApply}
						intl={props.intl}

					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="offers"
						placeholder={'Offers'}
						multi={false}
						searchable={true}
						options={props.offersLookup}
						component={SelectField}
						showLabel={false}
						onChange={() => {
							setTimeout(fetchOffersApproveData, 500);
						}}
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="countries"
						placeholder={props.intl('Countries')}
						multi={false}
						searchable={true}
						options={props.approveLocationsLookups.bind(null, false)}
						component={SelectField}
						showLabel={false}
						onChange={() => {
							setTimeout(fetchOffersApproveData, 500);
						}}
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="sid"
						placeholder={props.intl('Sid 1, 2, 3, 4 or 5 (optional)')}
						component={Input}
						showLabel={false}
						onChange={_debounce(fetchOffersApproveData, 500) }
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="target_approve"
						placeholder={props.intl('Target approve') + ', %'}
						type="number"
						normalize={
							(value, oldValue) => {
								if (!Number(value)) {
									return '';
								}
								return Number(value) >= 0 && Number(value) <= 100 ? Number(value) : oldValue;
							}
						}
						component={Input}
						showLabel={false}
						onChange={_debounce(fetchOffersApproveData, 500) }
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="comment"
						placeholder={props.intl('Comment')}
						component={Input}
						showLabel={false}
					/>
				</div>
				<div className="margin-bottom-10">{
					props.increaseApproveFormOfferApproveData
					&& props.increaseApproveFormOfferApproveData.map((row, index) =>
						<div className="margin-bottom-10" key={index}>
							<p className="info-row">
								Offer: {row.offer_title}. Total Leads {row.total_count} = Leads per day {row.leads_per_day}
							</p>
							{
								row.has_leads && !row.is_not_enough_approve &&
								<p className="warning-row">
									Current approve is {row.approval_percent}%, nothing will be done
								</p>
							}
							{
								row.has_leads && !row.is_enough_leads_per_day &&
								<p className="error-row">
									Can't increase approve: minimum leads per day is {row.past_approve_leads_per_day}
								</p>
							}
							{
								row.has_leads && !row.has_no_pending_leads &&
								<p className="error-row">
									Period includes pending leads, nothing will be done
								</p>
							}
							{
								!row.has_leads &&
								<p className="error-row">
									Has no leads
								</p>
							}
							{
								row.is_enough_leads_per_day
								&& row.is_not_enough_approve
								&& row.has_no_pending_leads
								&& row.has_leads
								&& <p>
									Current approve is {row.approval_percent}%. To increase it to
									{` ${row.target_approve}%`} need approve {row.rejected_to_approve} rejected
									leads + {row.trash_to_approve || 0} trash leads =
									{
										Object.keys(row.toBePayed)
											.filter(key => row.toBePayed[key] > 0)
											.map(key => `${row.toBePayed[key]} ${key.toUpperCase()} `)
											.join(';')
									}
									will be issued to affiliate. Approve after increasing
									{` ${Math.floor(row.approve_after_increasing * 100)/100}%`}
								</p>
							}
						</div>
					)}
				{
					_Empty(props.increaseApproveFormOfferApproveData)
					&& !!target_approve && !!offers && !!countries
					&& 'Nothing found'
				}
				</div>
				<button
					className={cn({
						'ui-btn': true,
						'ui-btn-primary apply': !props.isBlockedSubmitButton,
						'ui-btn-cancel cancel': props.isBlockedSubmitButton
					})}
					type='submit'
					disabled={props.isBlockedSubmitButton}
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleIncreaseApproveForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Increasing approve for closed period (no pending leads)')}
		body={Form(props)}
		isOpen={props.increaseApproveFormVisibility}
		onClose={props.toggleIncreaseApproveForm}
		className='form-modal increase-payout-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default formName => reduxForm({ form: formName })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/increase-approve-form/main.js